import { render, staticRenderFns } from "./MobileContact.vue?vue&type=template&id=64537d96&scoped=true"
import script from "./MobileContact.vue?vue&type=script&lang=js"
export * from "./MobileContact.vue?vue&type=script&lang=js"
import style0 from "./MobileContact.vue?vue&type=style&index=0&id=64537d96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64537d96",
  null
  
)

export default component.exports